(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5351],{

/***/ 2805:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[categorias]",
      function () {
        return __webpack_require__(3586);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [162,1216,8912,3213,7637,6911,8802,7590,944,2826,347,5582,9774,2888,179], function() { return __webpack_exec__(2805); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);